import { mapGetters } from "vuex";

export default {
  computed: {
    ...mapGetters("account", {
      "$_language": "displayLanguage"
    })
  },
  methods: {
    getLocaleText(text) {
      // let lang = this.$store.getters.ts["account/displayLanguage"];
      let language = this.$_language;
      if (!["fr", process.env.VUE_APP_I18N_LOCALE].includes(language)) {
        language = process.env.VUE_APP_I18N_LOCALE;
      }
      if (text[language] && text[language] != "") {
        return text[language];
      }
      if (text["en"]) {
        return text["en"]
      }
      return text;
    }
  }
};
